export const COLOR_full_background_default = '#F2F3F3'; //(--awsui-color-background-layout)
export const COLOR_appbar_background_default = '#ddd';
export const COLOR_text_button_background_primary_default = '#ff9100';    // ##ff9100
export const COLOR_content_background_layout_default = '#f2f3f3';
export const COLOR_text_base = '#16191f';                                   //  var(--awsui-color-text-base)
export const COLOR_text_nav_selected = '#ec7211';                    // var(--awsui-color-text-nav-selected)
export const COLOR_sidebar_background = '#EAEDED';

// 1F77B4 3E88BB
export const COLOR_chart_series_first_line = '#1F77B4';

export const COLOR_shadow_medium = 'rgba(0,28,36,0.3)';
export const COLOR_shadow_side  = 'rgba(0,28,36,0.15)';


//testes azul para grafico
// #3E88BB
// #257BB6
